import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";
import * as types from "@/store/constants/types";
import { isIos } from "@/utils/lodash";

var VideoPlayer =
/*#__PURE__*/
function (_Vue) {
  _inherits(VideoPlayer, _Vue);

  function VideoPlayer() {
    var _this;

    _classCallCheck(this, VideoPlayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VideoPlayer).apply(this, arguments));
    _this.maskShow = true;
    return _this;
  }

  _createClass(VideoPlayer, [{
    key: "endedEmit",
    value: function endedEmit() {
      console.log("endedEmit ended");
    }
  }, {
    key: "videoPlay",
    value: function videoPlay() {
      try {
        var videoEl = document.querySelector('.videoElement');

        if (this.videoSrc && videoEl) {
          var promise = videoEl.play();

          if (promise !== undefined) {
            promise.catch(function (error) {
              console.log("// Auto-play was prevented");
            }).then(function () {// console.log("Auto-play started");
            });
          }
        }
      } catch (err) {}
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.$nextTick(function () {
        var videoRef = _this2.$refs.videoRef;
        videoRef.addEventListener("canplaythrough", function () {
          // console.log("canplaythrough:", videoRef.currentTime);
          _this2.maskShow = false; // if (videoRef.currentTime > 0.5) {
          //   this.maskShow = false;
          // }
        });

        if (isIos()) {
          document.addEventListener("resume", _this2.videoPlay, false);
        }
      });
    }
  }, {
    key: "wrappeStyle",
    get: function get() {
      return {
        backgroundImage: "url(".concat(this.poster, ")"),
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
      };
    }
  }]);

  return VideoPlayer;
}(Vue);

tslib_1.__decorate([Mutation(types.HIDE_TOAST)], VideoPlayer.prototype, "hideToast", void 0);

tslib_1.__decorate([Getter(types.GETTER_TOAST)], VideoPlayer.prototype, "toastData", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], VideoPlayer.prototype, "poster", void 0);

tslib_1.__decorate([Prop({
  default: ""
})], VideoPlayer.prototype, "videoSrc", void 0);

tslib_1.__decorate([Prop({
  default: {}
})], VideoPlayer.prototype, "videoStyle", void 0);

tslib_1.__decorate([Prop({
  default: true
})], VideoPlayer.prototype, "needLoop", void 0);

tslib_1.__decorate([Emit("ended")], VideoPlayer.prototype, "endedEmit", null);

VideoPlayer = tslib_1.__decorate([Component({
  components: {}
})], VideoPlayer);
export default VideoPlayer;